import { Injectable } from '@angular/core';
import { ContractListItem } from '@app/features/contracts/contract.model';
import { Observable, of } from 'rxjs';
import { ContractHistorySource, HistoryEntry, HistoryOrigin } from './history-entry.model';

export const CONTRACT_ORIGIN: HistoryOrigin = { key: 'contrat', label: 'Contrat' };

/** La création du contrat, première entrée de son fil. */
@Injectable()
export class ContractCreationHistorySource implements ContractHistorySource {
  readonly origin = CONTRACT_ORIGIN;

  entries(contract: ContractListItem): Observable<HistoryEntry[]> {
    return of([
      {
        id: 'contrat-creation',
        origin: CONTRACT_ORIGIN,
        at: contract.createdAt,
        title: contract.createdBy
          ? ['Contrat créé par ', { userId: contract.createdBy }]
          : ['Contrat créé'],
      },
    ]);
  }
}
